import { Component, Input } from '@angular/core';

@Component({
  selector: 'insert-edit-percentage',
  templateUrl: './percentage.component.html'
})
export class PercentageComponent {
  @Input() fieldName!: string;
  @Input() label!: string;
  @Input() required: boolean = false;
  @Input() decimalDigits = 0;

  constructor() { }
}
